var render = function render(){var _vm=this,_c=_vm._self._c;return _c('thead',{staticClass:"hit-html-thead"},[_c('tr',{staticClass:"hit-html-tr"},_vm._l((_vm.titles),function(head,index){return _c('th',{staticClass:"hit-html-th"},[_c('i',{staticClass:"hit-glyphicon",class:_vm.get_icon(index)}),_c('span',{domProps:{"innerHTML":_vm._s(head)}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }